export default __webpack_public_path__ + "static/media/MultipleBeltsImg.dced1fec.png";